export default __webpack_public_path__ + "static/emergencySelected-5f304d0c30b293f2b2b905de70f5d25f.svg";